import { ORDER_PAGE_GONE_CODE } from '@messenger/consts'

/**
 * Whether a save was refused because its page is no longer on the line — its
 * layout was reset, replaced or restored somewhere else. The order-page PATCH
 * and the editor's text-box save answer with the one code, so the tab reads
 * it the same way whichever route refused.
 */
export const isOrderPageGoneError = (error: unknown): boolean =>
  (error as { response?: { data?: { code?: string } } })?.response?.data
    ?.code === ORDER_PAGE_GONE_CODE

export default isOrderPageGoneError
